/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ChecklisteIdListeRequest } from '../model/checklisteIdListeRequest';
// @ts-ignore
import { ChecklisteIdentifier } from '../model/checklisteIdentifier';
// @ts-ignore
import { ChecklisteModelRequest } from '../model/checklisteModelRequest';
// @ts-ignore
import { ChecklisteRequest } from '../model/checklisteRequest';
// @ts-ignore
import { ChecklisteVeranstaltungsTypMultiRequest } from '../model/checklisteVeranstaltungsTypMultiRequest';
// @ts-ignore
import { ChecklisteVerschiebenRequest } from '../model/checklisteVerschiebenRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class ChecklisteCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostChecklisteAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * ChecklisteGeloescht: (VorlageChecklisteGeloescht) * ChecklisteNichtGefunden: (VorlageChecklisteNichtGefunden) 
     * @endpoint post /api/vorl/command/checklisten/v1/aktualisieren
     * @param checklisteModelRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteAktualisieren(checklisteModelRequest: ChecklisteModelRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteAktualisieren(checklisteModelRequest: ChecklisteModelRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteAktualisieren(checklisteModelRequest: ChecklisteModelRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteAktualisieren(checklisteModelRequest: ChecklisteModelRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteModelRequest === null || checklisteModelRequest === undefined) {
            throw new Error('Required parameter checklisteModelRequest was null or undefined when calling postChecklisteAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteModelRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteAnlegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/vorl/command/checklisten/v1/anlegen
     * @param checklisteModelRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteAnlegen(checklisteModelRequest: ChecklisteModelRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteAnlegen(checklisteModelRequest: ChecklisteModelRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteAnlegen(checklisteModelRequest: ChecklisteModelRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteAnlegen(checklisteModelRequest: ChecklisteModelRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteModelRequest === null || checklisteModelRequest === undefined) {
            throw new Error('Required parameter checklisteModelRequest was null or undefined when calling postChecklisteAnlegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteModelRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteKopieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * ChecklisteGeloescht: (VorlageChecklisteGeloescht) * ChecklisteNichtGefunden: (VorlageChecklisteNichtGefunden) 
     * @endpoint post /api/vorl/command/checklisten/v1/kopieren
     * @param checklisteRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteKopieren(checklisteRequest: ChecklisteRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteKopieren(checklisteRequest: ChecklisteRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteKopieren(checklisteRequest: ChecklisteRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteKopieren(checklisteRequest: ChecklisteRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteRequest === null || checklisteRequest === undefined) {
            throw new Error('Required parameter checklisteRequest was null or undefined when calling postChecklisteKopieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/kopieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteLoeschen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * ChecklisteGeloescht: (VorlageChecklisteGeloescht) * ChecklisteNichtGefunden: (VorlageChecklisteNichtGefunden) 
     * @endpoint post /api/vorl/command/checklisten/v1/loeschen
     * @param checklisteRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteLoeschen(checklisteRequest: ChecklisteRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteLoeschen(checklisteRequest: ChecklisteRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteLoeschen(checklisteRequest: ChecklisteRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteLoeschen(checklisteRequest: ChecklisteRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteRequest === null || checklisteRequest === undefined) {
            throw new Error('Required parameter checklisteRequest was null or undefined when calling postChecklisteLoeschen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/loeschen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteReihenfolgen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/vorl/command/checklisten/v1/reihenfolgen
     * @param checklisteIdListeRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteReihenfolgen(checklisteIdListeRequest: ChecklisteIdListeRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public postChecklisteReihenfolgen(checklisteIdListeRequest: ChecklisteIdListeRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public postChecklisteReihenfolgen(checklisteIdListeRequest: ChecklisteIdListeRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public postChecklisteReihenfolgen(checklisteIdListeRequest: ChecklisteIdListeRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteIdListeRequest === null || checklisteIdListeRequest === undefined) {
            throw new Error('Required parameter checklisteIdListeRequest was null or undefined when calling postChecklisteReihenfolgen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/reihenfolgen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteIdListeRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteVeranstaltungsTypenAktivieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * ChecklisteGeloescht: (VorlageChecklisteGeloescht) * ChecklisteNichtGefunden: (VorlageChecklisteNichtGefunden) 
     * @endpoint post /api/vorl/command/checklisten/v1/veranstaltungstypen/aktivieren
     * @param checklisteRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteVeranstaltungsTypenAktivieren(checklisteRequest: ChecklisteRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteVeranstaltungsTypenAktivieren(checklisteRequest: ChecklisteRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteVeranstaltungsTypenAktivieren(checklisteRequest: ChecklisteRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteVeranstaltungsTypenAktivieren(checklisteRequest: ChecklisteRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteRequest === null || checklisteRequest === undefined) {
            throw new Error('Required parameter checklisteRequest was null or undefined when calling postChecklisteVeranstaltungsTypenAktivieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/veranstaltungstypen/aktivieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteVeranstaltungsTypenDeaktivieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * ChecklisteGeloescht: (VorlageChecklisteGeloescht) * ChecklisteNichtGefunden: (VorlageChecklisteNichtGefunden) 
     * @endpoint post /api/vorl/command/checklisten/v1/veranstaltungstypen/deaktivieren
     * @param checklisteRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteVeranstaltungsTypenDeaktivieren(checklisteRequest: ChecklisteRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteVeranstaltungsTypenDeaktivieren(checklisteRequest: ChecklisteRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteVeranstaltungsTypenDeaktivieren(checklisteRequest: ChecklisteRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteVeranstaltungsTypenDeaktivieren(checklisteRequest: ChecklisteRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteRequest === null || checklisteRequest === undefined) {
            throw new Error('Required parameter checklisteRequest was null or undefined when calling postChecklisteVeranstaltungsTypenDeaktivieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/veranstaltungstypen/deaktivieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteVeranstaltungsTypenEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * ChecklisteGeloescht: (VorlageChecklisteGeloescht) * ChecklisteNichtGefunden: (VorlageChecklisteNichtGefunden) 
     * @endpoint post /api/vorl/command/checklisten/v1/veranstaltungstypen/entfernen
     * @param checklisteVeranstaltungsTypMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteVeranstaltungsTypenEntfernen(checklisteVeranstaltungsTypMultiRequest: ChecklisteVeranstaltungsTypMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteVeranstaltungsTypenEntfernen(checklisteVeranstaltungsTypMultiRequest: ChecklisteVeranstaltungsTypMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteVeranstaltungsTypenEntfernen(checklisteVeranstaltungsTypMultiRequest: ChecklisteVeranstaltungsTypMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteVeranstaltungsTypenEntfernen(checklisteVeranstaltungsTypMultiRequest: ChecklisteVeranstaltungsTypMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteVeranstaltungsTypMultiRequest === null || checklisteVeranstaltungsTypMultiRequest === undefined) {
            throw new Error('Required parameter checklisteVeranstaltungsTypMultiRequest was null or undefined when calling postChecklisteVeranstaltungsTypenEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/veranstaltungstypen/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteVeranstaltungsTypMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteVeranstaltungsTypenHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * ChecklisteGeloescht: (VorlageChecklisteGeloescht) * ChecklisteNichtGefunden: (VorlageChecklisteNichtGefunden) 
     * @endpoint post /api/vorl/command/checklisten/v1/veranstaltungstypen/hinzufuegen
     * @param checklisteVeranstaltungsTypMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteVeranstaltungsTypenHinzufuegen(checklisteVeranstaltungsTypMultiRequest: ChecklisteVeranstaltungsTypMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteVeranstaltungsTypenHinzufuegen(checklisteVeranstaltungsTypMultiRequest: ChecklisteVeranstaltungsTypMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteVeranstaltungsTypenHinzufuegen(checklisteVeranstaltungsTypMultiRequest: ChecklisteVeranstaltungsTypMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteVeranstaltungsTypenHinzufuegen(checklisteVeranstaltungsTypMultiRequest: ChecklisteVeranstaltungsTypMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteVeranstaltungsTypMultiRequest === null || checklisteVeranstaltungsTypMultiRequest === undefined) {
            throw new Error('Required parameter checklisteVeranstaltungsTypMultiRequest was null or undefined when calling postChecklisteVeranstaltungsTypenHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/veranstaltungstypen/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteVeranstaltungsTypMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostChecklisteVerschieben
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * ChecklisteGeloescht: (VorlageChecklisteGeloescht) * ChecklisteNichtGefunden: (VorlageChecklisteNichtGefunden) 
     * @endpoint post /api/vorl/command/checklisten/v1/verschieben
     * @param checklisteVerschiebenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postChecklisteVerschieben(checklisteVerschiebenRequest: ChecklisteVerschiebenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ChecklisteIdentifier>;
    public postChecklisteVerschieben(checklisteVerschiebenRequest: ChecklisteVerschiebenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ChecklisteIdentifier>>;
    public postChecklisteVerschieben(checklisteVerschiebenRequest: ChecklisteVerschiebenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ChecklisteIdentifier>>;
    public postChecklisteVerschieben(checklisteVerschiebenRequest: ChecklisteVerschiebenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (checklisteVerschiebenRequest === null || checklisteVerschiebenRequest === undefined) {
            throw new Error('Required parameter checklisteVerschiebenRequest was null or undefined when calling postChecklisteVerschieben.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vorl/command/checklisten/v1/verschieben`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ChecklisteIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: checklisteVerschiebenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
